<template lang="pug">
  .the-loader
    .loader__logo
      img(src='../assets/playmetrix-logo.png')
      SelfBuildingSquareSpinner(
        :size='50',
        color='#E8D26F'
      )
</template>

<script>
import { SelfBuildingSquareSpinner } from 'epic-spinners'

export default {
  name: 'the-loader',
  components: {
    SelfBuildingSquareSpinner   
  }
}
</script>

<style scoped>
.the-loader {
  position: absolute;
  z-index: 10;
  width: 100%;
  height: 100%;
  background-color: #F0F5F9;
  display: flex;
  justify-content: center;
  align-items: center;
  /* color: #fff; */
}
.loader__logo {
  display: flex;
  align-items: center;
  flex-direction: column;
}
.loader__logo img {
  width: 100px;
  margin-bottom: 10px;
}
</style>